import { render, staticRenderFns } from "./Crear_notificacion.vue?vue&type=template&id=e6c22c9e&scoped=true&"
import script from "./Crear_notificacion.vue?vue&type=script&lang=js&"
export * from "./Crear_notificacion.vue?vue&type=script&lang=js&"
import style0 from "./Crear_notificacion.vue?vue&type=style&index=0&id=e6c22c9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c22c9e",
  null
  
)

export default component.exports